module.exports = __webpack_public_path__ + "img/pasture_cynodon_high.6394cc38.webp";